<script lang="ts">
	import BaseNode from './BaseNode.svelte';
	import type { NodeData } from '../types/flow-types';

	export let id: string;
	export let data: NodeData;
	export let selected: boolean = false;
	export let validated: boolean = true;
	export let errors: string[] = [];

	$: steps = (Array.isArray(data.steps) ? data.steps : []) as Array<Record<string, unknown>>;
	$: delays = steps.filter((step) => step.type === 'wait').length;
	$: title = steps.length
		? `${steps.length} ${steps.length === 1 ? 'step' : 'steps'}`
		: 'Add sequence steps';

	function stepLabel(step: Record<string, unknown>): string {
		if (step.type === 'wait') {
			const value = Number(step.value || 0);
			return `Wait ${value} ${step.units === 'min' ? (value === 1 ? 'minute' : 'minutes') : value === 1 ? 'second' : 'seconds'}`;
		}
		if (step.type === 'setVariable') return `Set ${step.name || 'variable'} to ${step.value ?? ''}`;
		const kind = step.notificationType === 'event_log' ? 'Event log' : 'Notification';
		return `${kind}: ${String(step.message || 'add a message')}`;
	}
</script>

<BaseNode
	{id}
	type="actionSequence"
	{data}
	{selected}
	validated={validated && steps.length > 0}
	{errors}
	cardTitle={title}
	nodeTypeLabel="Action sequence"
	avatarOverride={{ icon: 'fa-solid fa-list-ol', backgroundColor: 'color-base' }}
	{...$$restProps}
>
	<div class="sequence-list">
		{#each steps.slice(0, 4) as step, index (step.id || index)}
			<div class="sequence-step">
				<span>{index + 1}</span>
				<div>{stepLabel(step)}</div>
			</div>
		{/each}
		{#if steps.length > 4}<div class="more">+{steps.length - 4} more</div>{/if}
		{#if delays}<div class="meta">{delays} {delays === 1 ? 'delay' : 'delays'} included</div>{/if}
	</div>
</BaseNode>

<style>
	.sequence-list {
		display: flex;
		min-width: 14rem;
		flex-direction: column;
		gap: 0.25rem;
	}
	.sequence-step {
		display: grid;
		grid-template-columns: 1.3rem minmax(0, 1fr);
		align-items: center;
		gap: 0.4rem;
		color: var(--flow-slot-strong);
		font-size: 0.72rem;
	}
	.sequence-step > span {
		display: inline-flex;
		width: 1.2rem;
		height: 1.2rem;
		align-items: center;
		justify-content: center;
		border-radius: 50%;
		background: color-mix(in srgb, #8b5cf6 18%, transparent);
		color: #8b5cf6;
		font-weight: 800;
	}
	.sequence-step > div {
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}
	.more,
	.meta {
		color: var(--flow-slot-muted);
		font-size: 0.68rem;
	}
</style>
